class PaginationInfinite extends HTMLElement {
  constructor() {
    super();
    this.pageSelector = this.dataset.container;
    this.loader = document.querySelector("loading-bar");
    this.itemSelector = this.dataset.item;
    this.loading = false;
    this.observer = null;
    this.onScroll = this.checkPosition.bind(this);
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      this.loadNextPage();
    };
    this.observer = new IntersectionObserver(handleIntersection.bind(this), {rootMargin: this.dataset.margin, threshold: 0});
    this.observer.observe(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    this.checkPosition();
  }

  disconnectedCallback() {
    this.observer && this.observer.disconnect();
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  checkPosition() {
    const grid = document.querySelector(this.pageSelector);
    if (!grid) return;
    const next = this.querySelector('.page-link-next');
    if (!next) return;
    const threshold = 120;
    const gridBottom = grid.getBoundingClientRect().bottom;
    if (gridBottom - window.innerHeight < threshold) {
      this.loadNextPage();
    }
  }

  loadNextPage() {
    const urlNextElement = this.querySelector('.page-link-next');
    if (!urlNextElement) return;
    if (this.loading) return;
    this.loading = true;
    this.classList.add('is-loading');
    this.loader && this.loader.start();
    this.toggleLoading();
    const url = urlNextElement.href.split('#')[0];
    fetch(url)
      .then(response => {
        return response.text();
      })
      .then(html => {
        setTimeout(() => {
          this.renderCurrentPage(html, url);
        }, 2400);
      })
      .catch(e => {
        console.error(e);
        this.disableLoading();
        this.loading = false;
      }).finally(() => {
      });
  }

  toggleLoading(){
    const loadingTextElement = document.querySelector('[data-loading-text]');
    const elementNextLink = document.querySelector('.page-link-next');
    if (elementNextLink && loadingTextElement) {
      loadingTextElement.querySelectorAll('span').forEach(item => item.classList.toggle('hidden'));
    }
  }

  disableLoading(){
    const loadingTextElement = document.querySelector('[data-loading-text]');
    const loadingText = loadingTextElement && loadingTextElement.querySelector('.loading-text');
    if (loadingText && !loadingText.classList.contains('hidden')) {
      this.toggleLoading();
    }
  }

  renderCurrentPage(html, url) {
    const renderedDocument = new DOMParser().parseFromString(html, 'text/html');

    if (!renderedDocument.querySelector(this.pageSelector)) return;

    const destination = document.querySelector(this.pageSelector);
    const source = renderedDocument.querySelector(this.pageSelector);
    destination.append(...source.querySelectorAll(this.itemSelector));

    const element = this;
    const elementSource = renderedDocument.querySelector('pagination-infinite');
    if (elementSource) {
      element.innerHTML = elementSource.innerHTML;
      const next = element.querySelector('.page-link-next');
      if (next) {
        let nextUrl = new URL(next.href);
        nextUrl.searchParams.delete('view');
        nextUrl.searchParams.delete('section_id');
        next.href = nextUrl.href;
      }
    } else {
      element.innerHTML = '';
      this.observer && this.observer.disconnect();
    }

    'updateUrl' in this.dataset && this.updateURLHash(url);
    setTimeout(() => {
      this.loader && this.loader.hide();
    }, 500);
    this.disableLoading();
    this.classList.remove('is-loading');
    this.loading = false;
    window.requestAnimationFrame(() => this.checkPosition());
  }

  updateURLHash(link) {
    let url = new URL(link);
    url.searchParams.delete('view');
    url.searchParams.delete('section_id');
    url = url.href;
    history.pushState({ url }, '', `${url}`);
  }
}
if (!customElements.get('pagination-infinite')) {
  customElements.define('pagination-infinite', PaginationInfinite);
}
